import React, { Component } from "react";
import { connect } from "react-redux";
import Header from "../components/common/Header";
import SideBar from "../components/common/SideBar";
import PMCReRegistrationLeftBox from "../components/re_registration/pmc_rereg/PMCReRegistrationLeftBox";
import ReRegArticulationLeftBox from "../components/re_registration/ReRegArticulationLeftBox";
import PMCReRegistrationSidebar from "../components/re_registration/Sidebar/PMCReRegistrationSidebar";
import ReRegistrationLeftBox from "../components/re_registration/ReRegistrationLeftBox";
import ReRegistrationRightBox from "../components/re_registration/ReRegistrationRightBox";
import { getReRegistrationService } from "../services/ReRegistrationService";


const initAvailableSteps = {
  articulation: [0, 1],  // Articulation
  reReg: [0, 4],         // Classic ReReg
  pmc: [1, 2]            // PMC ReReg (step 1 = Review Module Selection, step 2 = Review Account Details)
  // Step 5 (Supporting Documents) is added dynamically when files are required
};

class ReRegistrationSchool extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registration: null,
      /**
       * From Reducer.state (localstorage), contains graduated flag.
       */
      registrationFullData: null,
      /**
       * Only for Articulation when first step is done, this will be populated.
       */
      articulationOptionSelected: null,
      studentStatus: false,
      progressBar: false,
      reRegistrationList: [],
      isPmcReRegistration: false,
      currentStep: 0,
      stepsAvailable: initAvailableSteps.reReg,
      submitted: false,
      activeTab: "overview",
      moduleSummary: null,
      readOnlyData: null
    };
    console.error = () => { }
    console.warn = () => { }
  }
  setReadOnlyData = (readOnlyData) => {
    if (this?.state) {
      this.setState({ readOnlyData });
    }
  }
  setIsPmcReRegistration = (val) => {
    if (this?.state) {
      this.setState({ isPmcReRegistration: val });
    }
  };
  setCurrentStep = (val, options = {}) => {
    if (this?.state) {
      // Articulation Flow (isGraduated), but articulation only has 2 steps (0 & 1)
      const step = this.isGraduated() && val >= 2 ? 1 : val;
      const shouldSyncTab = !this.isGraduated() && this.isPmcDriven() && options?.skipTabSync !== true;
      this.setState(prevState => ({
        currentStep: step,
        ...((shouldSyncTab && step === 5) &&  {
          activeTab: "supporting_documents"
        })
      }));
    }
  };
  setStepsAvailable = (val) => {
    if (this?.state) {
      if (!this.isGraduated()) {
        this.setState({ stepsAvailable: val });
      } else {
        // Articulation flow (isGraduated) only has step 1 and 2 available steps:
        this.setState({ stepsAvailable: initAvailableSteps.articulation });
      }
    }
  }
  setSubmitted = (val) => {
    if (this?.state) {
      this.setState({ submitted: val });
    }
  }
  setRegistration = (registration) => {
    this.setState({ registration });
  }
  setRegistrationFullData = (registrationFullData) => {
    this.setState({ registrationFullData });
  }
  /**
   * Only if isGraduated (Articulation Flow).
   * @param {object} articulationOptionSelected Selected articulation object.
   */
  setArticulationOption = (articulationOptionSelected) => {
    this.setState({ articulationOptionSelected });
  }
  setActiveTab = (val) => {
    if (this?.state) {
      if (!this.isGraduated()) {
        this.setState({ activeTab: val });
      } else {
        // isGraduated (Articulation flow) only has one tab ('application'):
        this.setState({ activeTab: 'application' });
      }
    }
  }
  setModuleSummary = (moduleSummary) => {
    if (this?.state) {
      this.setState(prevState => ({
        moduleSummary: {
          ...(prevState?.moduleSummary || {}),
          ...(moduleSummary || {})
        }
      }));
    }
  }
  goToApplicationTab = () => {
    this.setActiveTab("application");
    // Don't reset the step when navigating to application tab
    // Let the step remain as set by the completion logic
  }
  componentDidMount() {
    
    if (this?.props && this?.props.match) {
      getReRegistrationService(this?.props.match.params.regid).then((res) => {
        // Will invoke componentDidUpdate to set registrationFullData
        this.setRegistration(res.data);
      });
    }
  }
  
  checkReRegCombinedListChanged(prevProps, prevState) {
    const reRegCombinedListChanged = prevProps.reRegCombinedList?.length !== this.props.reRegCombinedList?.length;
    const registrationChanged = prevState.registration !== this.state.registration;

    return { reRegCombinedListChanged, registrationChanged };
  }
  checkArticulationRegChanged(prevProps, prevState) {
    const graduated = this.isGraduated();
    const articulationReg = Boolean(graduated && this?.state?.registration);
    const articulationRegPrev = Boolean(graduated && prevState.registration);

    return { articulationRegChanged: articulationRegPrev !== articulationReg, articulationReg };
  }
  checkClassicReRegChanged(prevState) {
    const classicReReg = Boolean(this?.state?.registration && !this.isPmcDriven());
    const classicReRegPrev = Boolean(prevState.registration && !prevState.isPmcReRegistration);

    return { classicReRegChanged: classicReRegPrev !== classicReReg, classicReReg };
  }
  checkPMCReRegChanged(prevState) {
    const pmcReReg = Boolean(this?.state?.registration && this.isPmcDriven());
    const pmcReRegPrev = Boolean(prevState.registration && prevState.isPmcReRegistration);

    return { pmcReRegChanged: pmcReRegPrev !== pmcReReg, pmcReReg };
  }
  componentDidUpdate(prevProps, prevState) {
    const { reRegCombinedListChanged, registrationChanged } = this.checkReRegCombinedListChanged(prevProps, prevState);
    if ((reRegCombinedListChanged || registrationChanged) && this.state.registration) {
      const match = this.props.reRegCombinedList.find(x => x.id === this.state.registration.id);
      this.setRegistrationFullData(match);
    }

    const { articulationRegChanged, articulationReg } = this.checkArticulationRegChanged(prevProps, prevState);
    const { classicReRegChanged, classicReReg } = this.checkClassicReRegChanged(prevState);
    const { pmcReRegChanged, pmcReReg } = this.checkPMCReRegChanged(prevState);
    // Detect if there was a change in rereg-process:
    if (articulationRegChanged || classicReRegChanged || pmcReRegChanged) {
      if (articulationReg) {
        this.setStepsAvailable(initAvailableSteps.articulation);
        this.setCurrentStep(0);
        this.setActiveTab("application");
      } else if (pmcReReg) {
        this.setStepsAvailable(initAvailableSteps.pmc);
      } else if (classicReReg) {
        this.setStepsAvailable(initAvailableSteps.reReg);
        this.setCurrentStep(0);
        this.setActiveTab("application");
      }
    }
  }
  updateStatus = () => {
    this.setState({ studentStatus: true, progressBar: true });
  };
  isGraduated() {
    return this.state.registrationFullData ? this.state.registrationFullData.graduated : false;
  }
  getPmcId() {
    return this.state.registrationFullData?.PMCId ?? '';
  }
  isPmcDriven() {
    // Check if registration is PMC-driven
    // This is set by ReRegistrationRightBox when it detects pmc_id and netsuite_id
    return Boolean(this.state.isPmcReRegistration);
  }
  render() {
    const graduated = this.isGraduated();
    const detailWrapClassName = `re-registration-detail-wrap d-flex  h-100${this.state.isPmcReRegistration ? " pmc-reregistration" : ""}`;
    const renderRegLeftBox = () => {
      const articulationReg = graduated && this?.state?.registration;
      if (articulationReg) {
        return (
          <ReRegArticulationLeftBox
            registration={this.state.registration}
            studentStatus={this.state.studentStatus}
            progressBar={this.state.progressBar}
            currentStep={this.state.currentStep}
            hasFileUpload={this.state.hasFileUpload}
            stepsAvailable={this.state.stepsAvailable}
            submitted={this.state.submitted}
            isArticulationOptionSelected={Boolean(this.state.articulationOptionSelected)}
            setCurrentStep={this.setCurrentStep}
          />
        );
      }
      const classicReReg = Boolean(this?.state?.registration && !this.isPmcDriven());
      if (classicReReg) {
        return (
          <ReRegistrationLeftBox
            registration={this?.state?.registration}
            studentStatus={this?.state?.studentStatus}
            progressBar={this?.state?.progressBar}
          />
        );
      } else {
        return (
          <PMCReRegistrationSidebar
            registration={this?.state?.registrationFullData}
            paymentMethod={this?.state?.registration?.sponsor_payment_method }
            studentStatus={this?.state?.studentStatus}
            progressBar={this?.state?.progressBar}
            currentStep={this?.state?.currentStep}
            hasFileUpload={this?.state?.hasFileUpload}
            stepsAvailable={this?.state?.stepsAvailable}
            submitted={this?.state?.submitted}
            activeTab={this.state.activeTab}
            onStartReRegistration={this.goToApplicationTab}
            moduleSummary={this.state.moduleSummary}
            onStepClick={(step) => this.setCurrentStep(step)}
            onTabChange={this.setActiveTab}
            readOnlyData={this.state.readOnlyData}
            reRegCombinedList={this.props.reRegCombinedList}
          />
        );
      }
    };

    const renderRegRightBox = () => {
      const graduated = this.isGraduated();
      const pmcId = this.getPmcId();
      return (
        this?.state?.registration && (
          <ReRegistrationRightBox
            registrationFullData={this.state.registrationFullData}
            articulationOptionSelected={this.state.articulationOptionSelected}
            setArticulationOption={this.setArticulationOption}
            pmcId={pmcId}
            graduated={graduated}
            registration={this?.state?.registration}
            updateStatus={this?.updateStatus}
            setIsPmcReRegistration={this?.setIsPmcReRegistration}
            setCurrentStep={this?.setCurrentStep}
            setStepsAvailable={this?.setStepsAvailable}
            currentStep={this?.state?.currentStep}
            stepsAvailable={this?.state?.stepsAvailable}
            setSubmitted={this?.setSubmitted}
            submitted={this?.state?.submitted}
            activeTab={this.state.activeTab}
            onActiveTabChange={this.setActiveTab}
            onModuleSummaryChange={this.setModuleSummary}
            setRegistration={this.setRegistration}
            setRegistrationFullData={this.setRegistrationFullData}
            onReadOnlyDataChange={this.setReadOnlyData}
            totalAmount={this.state.moduleSummary?.totalAmount}
            depositAmount = {this.state.moduleSummary?.depositAmount}
          />
        )
      );
    };
    return (
      <>
        <Header></Header>
        <div className="content-wrapper d-flex flex-wrap">
          <SideBar></SideBar>
          <div className="sidebar-right">
            <div className={detailWrapClassName}>
              {renderRegLeftBox()}
              {renderRegRightBox()}
            </div>
          </div>
        </div>
      </>
    );
  }
}

/**
 * Combines open and closed reregistrations in order for ReRegistrationSchool.componentDidUpdate to find and set registrationFullData.
 * @param {object} state Saved in Localstorage (from Reducer).
 * @returns State mapped to props to use in ReRegistrationSchool.
 */
const mapStateToProps = (state) => {
  const { open, closed } = state.registrations;

  return ({
    reRegCombinedList: [...open, ...closed]
  })
};

export default connect(mapStateToProps)(ReRegistrationSchool);
